import React, { useState, useEffect } from "react";
import VideoPreview from "../../../../WidgetMaker/VideoPreview";
import defaultImg from "../../../../../assets/WidgetMaker/Brocken_Image.svg";
import Image from "antd/lib/image";
import { useSelector } from "react-redux";
import CarouselWidgetMaker from "../../../../WidgetMaker/Carousel";
import moment from "moment";
import uuid from "react-uuid";
import isEqual from "react-fast-compare";
import { Tooltip } from "antd";
const GallaryAttachments = ({
  cardData,
  index,
  PdfDownloadStatus,
  PptGeneratingStatus,
  isPreviewState,
  postText,
  deepDive,
  trendView,
  isCommandCenterScreen,
  custom_card_settings,
  center,
  isCurrentSlide,
  isTrandsView = false,
  gallaryCardHeight,
}) => {
  const authParams = useSelector((state) => state?.Authentication?.authParams);
  const personalizationSettingsObj = useSelector(
    (state) => state?.PersonalizationSetting
  );
  const [isImage, setIsImage] = useState({});

  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);

  const [videoPreview, setVideoPreview] = useState();
  const [isValidUrlFlag, setIsValidUrlFlag] = useState(null);

  const onImageError = (e, id) => {
    if (e?.type === "error") {
      setIsImage({
        ...isImage,
        [id]: true,
      });
    } else {
      setIsImage({
        ...isImage,
        [id]: false,
      });
    }
    return (e.target.src = defaultImg);
  };
  const isScontentLinkExpire = (mediaUrl, channelType) => {
    let isExpired = false;
    try {
      if (
        mediaUrl &&
        mediaUrl.indexOf("s3.amazonaws") == -1 &&
        mediaUrl.indexOf("images.locobuzz.com") == -1
      ) {
        const tokens = mediaUrl.split("&");
        const HexDecimalCode = tokens.filter((x) => x.includes("oe="));
        if (
          HexDecimalCode != null &&
          HexDecimalCode.length > 0 &&
          HexDecimalCode[0].startsWith("oe=")
        ) {
          let DecimalEpoch = 0;
          if (HexDecimalCode.length > 0) {
            const HexDecimalTime = HexDecimalCode[0].replace("oe=", "");
            DecimalEpoch = parseInt(HexDecimalTime, 16);
          }
          // DateTimeOffset.Now.ToUnixTimeSeconds()
          if (moment().unix() > DecimalEpoch && DecimalEpoch > 0) {
            isExpired = true;
          }
        }
      }
    } catch (exception) {
      return false;
    }

    return isExpired;
  };
  const handleVideoPreview = (imgUrl) => {
    if (personalizationSettingsObj?.isPersonalizationPreviewOpen) {
      return;
    }
    setIsVideoModalOpen(true);
    setVideoPreview(imgUrl?.MediaUrl);

    let isValidUrlFlag = isScontentLinkExpire(imgUrl?.MediaUrl, 1);
    setIsValidUrlFlag(isValidUrlFlag);
  };
  return (
    <>
      {cardData?.Attachment?.length === 1 ? (
        <div
          className={
            "m-0 w-100 h-100 text-center position-relative attachment_image"
          }
        >
          {cardData?.Attachment?.length > 0 &&
            cardData?.Attachment?.map((imgUrl, ind) => {
              if (imgUrl?.MediaType === "2" || imgUrl?.MediaType === "4") {
                return imgUrl ? (
                  <>
                    <Image
                      src={imgUrl?.ThumbUrl ? imgUrl?.ThumbUrl : defaultImg}
                      className="gallary--image"
                      alt="Preview Group"
                      fallback={defaultImg}
                      preview={false}
                      style={{
                        height: "100%",
                        objectFit:
                          center || isCurrentSlide ? "contain" : "cover",
                      }}
                      key={`GallaryAttachmentsMedia_Image_${index + "" + ind}`}
                    />
                  </>
                ) : (
                  ""
                );
              } else if (
                imgUrl?.MediaType === "3" ||
                imgUrl?.MediaType === "7"
              ) {
                return imgUrl ? (
                  <>
                    {cardData?.PlatformID === 2 ||
                    cardData?.PlatformID === 4 ||
                    cardData?.PlatformID === 37 ? (
                      <a
                        href={imgUrl?.MediaUrl ? imgUrl?.MediaUrl : ""}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <div
                          className="overlay-play-button"
                          style={{
                            height: "100%",
                          }}
                        >
                          <img
                            src={
                              imgUrl?.ThumbUrl ? imgUrl?.ThumbUrl : defaultImg
                            }
                            alt="Attachment Images"
                            onError={(el) => onImageError(el, ind)}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit:
                                center || isCurrentSlide ? "contain" : "cover",
                            }}
                          />
                          <div className="overlay-play-button__overlay">
                            <div className="overlay-play-button__play">
                              <i
                                className="fa fa-play"
                                style={{
                                  fontSize: "1.2rem",
                                  color: "#fff",
                                }}
                              ></i>
                            </div>
                          </div>
                        </div>
                      </a>
                    ) : cardData?.PlatformID === 1 ||
                      cardData?.PlatformID === 3 ||
                      cardData?.PlatformID === 5 ||
                      cardData?.PlatformID === 42 ? (
                      <>
                        <div
                          style={{
                            height: "100%",
                          }}
                          className="overlay-play-button"
                          onClick={() => handleVideoPreview(imgUrl)}
                        >
                          <video
                            width="100%"
                            style={{
                              objectFit:
                                center || isCurrentSlide ? "contain" : "cover",
                              height: "100%",
                            }}
                            key={`GallaryAttachmentsMedia_Video_${
                              index + "" + ind
                            }`}
                            id={`GallaryAttachmentsMedia_Video_${
                              index + "" + ind + "" + uuid()
                            }`}
                            poster={imgUrl?.ThumbUrl ? imgUrl?.ThumbUrl : ""}
                            className="gallary--video"
                          >
                            <source src={imgUrl?.MediaUrl} type="video/mp4" />
                          </video>
                          <div className="overlay-play-button__overlay">
                            <Tooltip
                              title={
                                personalizationSettingsObj?.isPersonalizationPreviewOpen
                                  ? "Actions are not allowed while customizing"
                                  : ""
                              }
                            >
                              <div
                                className={`overlay-play-button__play ${
                                  personalizationSettingsObj?.isPersonalizationPreviewOpen
                                    ? "disabled-cursor"
                                    : ""
                                }`}
                              >
                                <i
                                  className="fa fa-play"
                                  style={{ fontSize: "1.2rem", color: "#fff" }}
                                ></i>
                              </div>
                            </Tooltip>
                          </div>
                        </div>
                      </>
                    ) : (
                      ""
                    )}

                    {/* For Video Preview */}
                    <VideoPreview
                      videoPreview={videoPreview}
                      setIsModalOpen={setIsVideoModalOpen}
                      isModalOpen={isVideoModalOpen}
                      isValidUrlFlag={isValidUrlFlag}
                    />
                  </>
                ) : (
                  ""
                );
              }
            })}
        </div>
      ) : cardData?.Attachment?.length > 1 ? (
        <div
          className={`text-center ${
            authParams?.screen_id && !deepDive && !trendView
              ? "carousel__wrapper h-100"
              : ""
          }`}
          //   style={{
          //     width: commandCenterInfluencersPageId
          //       ? "100%"
          //       : authParams?.screen_id && !deepDive && !trendView
          //       ? "30%"
          //       : "50%",
          //   }}
        >
          <CarouselWidgetMaker
            el={cardData}
            gallaryCardHeight={"100%"}
            deepDive={deepDive}
            isAutoPlay={center && isCurrentSlide ? true : false}
            isPreviewAllowed={false}
            isMediaContainScreen={center || isCurrentSlide ? true : false}
          />
        </div>
      ) : (
        ""
      )}
    </>
  );
};
export default React.memo(GallaryAttachments, isEqual);
